import React from 'react';
import { translate } from '../../Services/translation';

const ResellerStore = ({store, selectStore, isSelected}) => {
    const getStockIndicator = (stock) => {
        if (stock == 0) {
            return {html: <div className="dot--red"></div>}
        } else if (stock == 1) {
            return {html: <div className="triangle"></div>}
        } else {
            return {html: <div className="dot"></div>}
        } 
    };

    return (
        <div key={store.organizationId}>
            <div className="store-item">
                <div className="store-item__title-row">
                    <h3 className="store-item__title">{store.shopName} <span className="store-item__distance">{store.distance} {translate('brenderup.storelist.kilometers')}</span></h3>
                </div>
                <div className='store-item__bottom-row'>
                    <div className='store-item__left-column'>
                        <p className="store-item__address">{store.streetName} <br/> {store.zipCode}, {store.city} </p>
                        <div className="inStock-row">
                            {getStockIndicator(store.stock).html}
                            {store.stock > 0 ? 
                            <div>+{store.stock} {translate('storelist.isinstock')}</div> :
                            <div>{store.stock} {translate('storelist.isinstock')}</div>
                            }
                        </div>
                    </div>
                    <button className={`store-button ${isSelected ? 'button--selected' : 'button'}`} onClick={(e) => selectStore(e, store)}>
                        { isSelected
                            ? translate('brenderup.storelist.selectedstore') 
                            : translate('storelist.chosestore')
                        } 
                    </button>
                </div>
            </div>
        </div>
    )
}

export default ResellerStore;